export default "__VITE_ASSET__97abdc56__"